import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faEye, faEyeSlash, faKey} from "@fortawesome/free-solid-svg-icons";
import {Oval} from "react-loader-spinner";
import AuthAPI from '~/api/authApi';
import React, {useEffect, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import AuthApi from "~/api/authApi";

function ResetPassword() {
    const [valid, setValid] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const navigate = useNavigate();
    const email = queryParams.get("Email");
    const tokenCode = queryParams.get("TokenCode");
    const {
        register,
        handleSubmit,
        watch,
        formState: { errors }
    } = useForm();

    useEffect(() => {
        AuthApi.resetVerifyLink({
            Email: email,
            TokenCode: tokenCode
        }).then(res => {
            if(res.data?.Succeeded){
                setValid(true);
            }
            else{
                navigate(`/auth/failed?token=${tokenCode}`, { replace: true });
            }
        }).catch(error => {
            console.error(error);
        })
    }, []);

    const onSubmit = (data) => {
        const params = {
            Email: email,
            NewPassword: data.Password,
            TokenCode: tokenCode
        }
       AuthAPI.resetPassword(params)
            .then(res => {
                if(res.data?.Succeeded){
                    navigate(`/auth/reset-password/success`, { replace: true });
                }
                else{
                    navigate(`/auth/failed?token=${tokenCode}`, { replace: true });
                }
            })
           .catch(error => {
               console.error(error);
           })
    }

    return (
        <div className="px-xxl-5">
            {
                !valid && (
                    <div className="text-center mb-1 d-flex align-items-center flex-column">
                        <Oval
                            height="30"
                            width="30"
                            color="#2f5aa2"
                            ariaLabel="oval-loading"
                        />
                        <span className="text-primary fs-9 mt-2 fw-bold">Verifying your session...</span>
                    </div>
                )
            }
            {
                valid && (
                    <div className="text-center mb-6">
                        <h4 className="text-body-highlight">Reset new password</h4>
                        <p className="text-body-tertiary mb-3 fs-8-1">Please create your new password.</p>
                        <form className="mb-3" onSubmit={handleSubmit(onSubmit)}>
                            <div className="mb-3 text-start">
                                <label className="form-label" htmlFor="password">Password</label>
                                <div className="form-icon-container" data-password="data-password">
                                    <input className="form-control form-icon-input pe-6"
                                           id="password"
                                           type={!showPassword ? "password" : "text"}
                                           placeholder="Password"
                                           {...register("Password", {
                                               required: "Password is required.",
                                               pattern: {
                                                   value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,}$/,
                                                   message: "Password must have at least 6 characters, 1 lowercase, 1 uppercase, 1 number and 1 special character."
                                               }
                                           })}
                                           data-password-input="data-password-input"/>
                                    <FontAwesomeIcon icon={faKey} className="form-icon fs-9 text-body"/>
                                    <FontAwesomeIcon onClick={() => setShowPassword(prev => !prev)} icon={!showPassword ? faEye : faEyeSlash} className="fs-10 px-3 h-100 position-absolute top-0 end-0 cursor-pointer" style={{paddingBottom: "2px"}}/>
                                </div>
                                {errors.Password && (
                                    <p className="fs-9 fw-bold text-danger mt-1">{errors.Password.message}</p>
                                )}
                            </div>
                            <div className="mb-3 text-start">
                                <label className="form-label" htmlFor="confirmPassword">Confirm Password</label>
                                <div className="form-icon-container" data-password="data-password">
                                    <input className="form-control form-icon-input pe-6"
                                           id="confirmPassword"
                                           type={!showConfirmPassword ? "password" : "text"}
                                           placeholder="Confirm Password"
                                           data-password-input="data-password-input"
                                           {...register("PasswordConfirm", {
                                               required: "Confirm Password is required.",
                                               validate: value =>
                                                   value === watch("Password") || "Passwords do not match"
                                           })}/>
                                    <FontAwesomeIcon icon={faKey} className="form-icon fs-9 text-body"/>
                                    <FontAwesomeIcon onClick={() => setShowConfirmPassword(prev => !prev)} icon={!showConfirmPassword ? faEye : faEyeSlash} className="fs-10 px-3 h-100 position-absolute top-0 end-0 cursor-pointer" style={{paddingBottom: "2px"}}/>
                                </div>
                                {errors.PasswordConfirm && (
                                    <p className="fs-9 fw-bold text-danger mt-1">{errors.PasswordConfirm.message}</p>
                                )}
                            </div>
                            <button type="submit" className="btn btn-primary mt-4 w-100">Reset Password
                            </button>
                        </form>
                    </div>
                )
            }
        </div>
    )
}

export default ResetPassword;